import { AutocompleteApi } from "@algolia/autocomplete-js";
import { navigate } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import { connectSearchBox, SearchBoxProvided } from "react-instantsearch-core";
import { startAutocomplete } from '../search-autocomplete/search-autocomplete';
import { 
  SearchBoxBase,
  SearchBoxInput,
  AutocompleteResults 
} from "./search-box.styled";

type SearchContentType = {
  submitAction: "refine" | "urlNavigate"
  autofocus?: boolean
  setSelectedIndex?: (index: number) => void
} & SearchBoxProvided

const SearchBox = (props: SearchContentType) => {
  const { submitAction, refine, currentRefinement, setSelectedIndex } = props;
  const autocompleteRef = useRef<HTMLDivElement>(null);
  const autocompletePanelRef = useRef<HTMLDivElement>(null);
  const [autocomplete, setAutocomplete] = useState<AutocompleteApi<any>>();

  function onClick(query: string, index?: number, tabName?: string) {
    if(submitAction === "refine") {
      refine(query);
      setSelectedIndex && index && setSelectedIndex(index)
      autocomplete?.destroy();
      autocomplete?.refresh();
    }
    else if(submitAction === "urlNavigate") {
      navigate(`/search?query=${query}${tabName ? `&index=${tabName}` : ``}`);
    }
  }

  useEffect(() => {
    autocompleteRef.current && 
    autocompletePanelRef.current &&
    setAutocomplete(startAutocomplete(autocompleteRef.current, autocompletePanelRef.current, onClick, currentRefinement));
    /* 
      Sets searchbox to focus. Autofocus feature from algolia currently does not pull auto focus from another element. 
      When the search button is clicked there are other elements in focus and the library logs:
      `Autofocus processing was blocked because a document already has a focused element.`
    */
    if(props.autofocus){
      (autocompleteRef.current?.querySelector('input') as HTMLElement)?.focus();
    }
  }, []);

  return (
    <SearchBoxBase>
      <SearchBoxInput ref={autocompleteRef} />
      <AutocompleteResults ref={autocompletePanelRef} />
    </SearchBoxBase>
  );
};

export default connectSearchBox(SearchBox);